import React from "react";

function CustomSearch({
  searchKeyword,
  handleCustomSearch,
  handleKeyPress,
  clearSearch,
}) {
  return (
    <div>
      <div className="input-group">
        <input
          type="text"
          value={searchKeyword}
          className="form-control"
          placeholder="Search using name, email and phone"
          onChange={handleCustomSearch}
          onKeyDown={handleKeyPress}
          title="Search using name, email and phone"
          style={{height:40}}
        />
        <div className="input-group-append">
          <button
            onClick={clearSearch}
            className="btn btn-outline-secondary"
            type="button"
          >
            <i
              className={`fa fa-${
                searchKeyword.length > 0 ? "close" : "search"
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomSearch;